function setReceipts(data) {
	return {
		type: 'SET_RECEIPTS',
		payload: data,
	};
}

export { setReceipts };
